module.exports = __webpack_public_path__ + "img/Large-Bevel-Attachment-31.bdb1bb8e.png";